import React, { useState } from 'react';
import { Brain, RotateCcw, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { apiClient } from '../../api/client';

/** 🧠 Bot panelinin üstünde: öğrenilen profil aktifse hangi kuralların açık olduğunu ve botu ne kadar kısıtladığını gösterir; tek tuşla normal ayarlara döner. */
export default function ProfileBanner({ bot, mode, profile, onChanged }) {
    const [busy, setBusy] = useState(false);
    if (!profile?.ids?.length) return null;
    const items = profile.items || [];
    const revert = async () => {
        setBusy(true);
        try {
            await apiClient.post('/autotrade/learning/revert', { bot: items.some((i) => i.id === 'kinds_only') ? 'all' : bot, mode });
            toast.success('Normal ayarlara dönüldü — bot tüm türler / saatler / yönlerle çalışır');
            onChanged && onChanged();
        } catch (e) {
            toast.error(e?.response?.data?.detail || 'Geri alınamadı');
        } finally {
            setBusy(false);
        }
    };
    return (
        <div className="rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-2 flex flex-wrap items-start gap-2" data-testid={`profile-banner-${bot}`}>
            <Brain className="h-4 w-4 text-amber-300 mt-0.5" />
            <div className="min-w-0 flex-1">
                <div className="text-xs font-bold text-amber-100">Öğrenilen profil aktif — bot kısıtlı çalışıyor ({items.length} kural)</div>
                <ul className="text-[11px] text-amber-50/90 mt-0.5 space-y-0.5">
                    {items.map((it) => <li key={it.id} data-testid={`profile-banner-${bot}-${it.id}`}>• <b>{it.title}</b>{it.effect ? ` — ${it.effect}` : ''}</li>)}
                </ul>
                <div className="text-[10px] text-amber-200/70 mt-0.5">Bu kurallar dışındaki sinyaller "ayarlardan kapalı" diye atlanır. Bot az işlem açıyorsa önce buraya bak.</div>
            </div>
            <button type="button" disabled={busy} onClick={revert} className="inline-flex items-center gap-1 h-7 px-2.5 rounded bg-amber-400 text-slate-950 text-[11px] font-black hover:bg-amber-300 disabled:opacity-50" data-testid={`profile-banner-${bot}-revert`}>
                {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <RotateCcw className="h-3 w-3" />} Normal ayarlara dön
            </button>
        </div>
    );
}
